"use client";

import NotFoundPage from "@/components/subComponents/NotFoundPage";

export default function NotFound() {
  return <NotFoundPage />;
}
